import { useCallback, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router';

import { useUserActions } from '@/entities/user/model/user.store';
import { usePlaycoinWallet } from '@/entities/user/model/wallet.store';

import { ROUTE_PATHS } from '@/shared/config/router/types';
import { BoosterType } from '@/shared/ui/booster/booster.types';
import { useStickyBannerActions } from '@/shared/ui/sticky-banner';

import { BoosterStickyBanner } from '../ui';

export const PLAYCOIN_BOOSTER_BANNER_KEY = BoosterType.BOOSTER_PLAYCOIN;

export const usePlaycoinBoostStickyBanner = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const playcoinWallet = usePlaycoinWallet();

  const { fetchUser } = useUserActions();

  const boosterValue = playcoinWallet?.activeBooster?.value ?? 0;
  const activeTo = playcoinWallet?.activeBooster?.activeTo;
  const selectionKey = playcoinWallet?.activeBooster?.selectionKey;

  const { open: openBanner, close, updateProps } = useStickyBannerActions();

  let categoryPath = selectionKey ? `${ROUTE_PATHS.CATEGORY}/${selectionKey}` : undefined;

  if (categoryPath === pathname) {
    categoryPath = undefined;
  }

  useEffect(() => {
    updateProps(PLAYCOIN_BOOSTER_BANNER_KEY, {
      onClick: categoryPath
        ? () =>
            navigate(categoryPath, {
              state: { source: 'xp_booster_sticky_banner' },
            })
        : undefined,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryPath]);

  const handleEndTimer = useCallback(() => {
    close(PLAYCOIN_BOOSTER_BANNER_KEY);

    // Wallet may not be updated via WS
    fetchUser();
  }, [close, fetchUser]);

  const open = useCallback(() => {
    return openBanner(PLAYCOIN_BOOSTER_BANNER_KEY, {
      content: (
        <BoosterStickyBanner
          boosted={boosterValue}
          expireTime={activeTo}
          onEnd={handleEndTimer}
          boosterType={BoosterType.BOOSTER_PLAYCOIN}
        />
      ),
    });
  }, [openBanner, boosterValue, activeTo, handleEndTimer]);

  useEffect(() => {
    if (boosterValue && activeTo) {
      open();
      return;
    }

    if (!boosterValue || !activeTo) {
      close(PLAYCOIN_BOOSTER_BANNER_KEY);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTo, boosterValue]);

  return { open, close };
};
